/* istanbul ignore file */
import '../../css/index.scss';  //eslint-disable-line import/no-unassigned-import
import boot from '../boot';
import App from './App';

boot('root', 'external', App);
